import { RatingSentiment } from "./rating-form-field.types";
import { NEGATIVE_BAND_END_PERCENTAGE, POSITIVE_BAND_START_PERCENTAGE } from "./rating-form-field.constants";

/**
 * Colour band for one option on a numeric survey scale, from how far along the scale the option is.
 * The low end is negative, the middle is neutral, and the high end is positive. The last option is always positive,
 * so the top of a short scale, such as a five-point satisfaction score, is the positive colour.
 * @param index       Zero-based position of the option, from the low end.
 * @param optionCount How many options the scale has.
 * @returns           The sentiment band for that option.
 */
export const getRatingSentiment = (index: number, optionCount: number): RatingSentiment => {
    // Compare index / (optionCount - 1) with each percentage without dividing, so a one-option scale is positive.
    const lastIndex = optionCount - 1;

    if (index * 100 < NEGATIVE_BAND_END_PERCENTAGE * lastIndex) {
        return RatingSentiment.Negative;
    }

    if (index * 100 >= POSITIVE_BAND_START_PERCENTAGE * lastIndex) {
        return RatingSentiment.Positive;
    }

    return RatingSentiment.Neutral;
};
